// extracted by mini-css-extract-plugin
export var card = "InfoCard-module--card--6d2ed";